export type JsonMap = Record<string, unknown>;

let csrfToken: string | null = null;

export function setCsrfToken(value: string | null): void {
  csrfToken = value;
}

export class ApiError extends Error {
  constructor(public readonly status: number, public readonly code: string, message: string) {
    super(message);
  }
}

async function requestJson<T>(path: string, options: RequestInit, retryCsrf: boolean): Promise<T> {
  const method = options.method?.toUpperCase() ?? "GET";
  const headers = new Headers(options.headers);
  headers.set("accept", "application/json");
  if (options.body) headers.set("content-type", "application/json");
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && csrfToken) headers.set("x-csrf-token", csrfToken);
  const response = await fetch(path, { ...options, headers, credentials: "include" });
  if (response.status === 204) return undefined as T;
  const payload = await response.json().catch(() => ({})) as JsonMap;
  if (!response.ok) {
    const error = typeof payload.error === "object" && payload.error !== null ? payload.error as JsonMap : {};
    const code = String(error.code ?? "REQUEST_FAILED");
    if (retryCsrf && method !== "GET" && path !== "/v1/admin/session"
      && response.status === 403 && ["ADMIN_CSRF_INVALID", "ADMIN_CSRF_REQUIRED"].includes(code)) {
      await requestJson("/v1/admin/me", {}, false);
      return requestJson(path, options, false);
    }
    throw new ApiError(response.status, code, String(error.message ?? "Запрос не выполнен"));
  }
  if (typeof payload.csrfToken === "string") setCsrfToken(payload.csrfToken);
  return payload as T;
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  return requestJson(path, options, true);
}

export function query(params: Record<string, string | number | undefined>): string {
  const values = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) if (value !== undefined && value !== "") values.set(key, String(value));
  const text = values.toString();
  return text ? `?${text}` : "";
}
